import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Stack,
  Card,
  ChoiceList,
  Listbox,
  TextField,
  Checkbox,
  PageActions,
  FormLayout,
  Layout,
  Page,
  DropZone,
  Modal,
  Thumbnail,
  Text,
  Toast,
  List,
  InlineError,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axiosDefault from "axios";
import LoadingScreen from "../../Components/LoadingScreen";
const AddEditProjectInnovest = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const [isSaving, setIsSaving] = useState(
    props?.type === "edit" ? true : false
  );
  const handleChangeTitleEn = (value) => {
    setItem({
      ...item,
      titleEn: value,
    });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeTitleAr = (value) => {
    setItem({ ...item, titleAr: value });
    setTitleArError("");
  };
  const [titleArError, setTitleArError] = useState("");
  const handleChangeDescriptionEn = (value) => {
    setItem({ ...item, descriptionEn: value });
  };
  const handleChangeCtaLink = (value) => {
    setItem({ ...item, ctaLink: value });
  };
  const handleChangeDescriptionAr = (value) => {
    setItem({ ...item, descriptionAr: value });
  };
  const handleChangeText = (value) => {
    setItem({ ...item, text: value });
  };
  const handleChangeCountryEn = (value) => {
    setItem({ ...item, countryEn: value });
  };
  const handleChangeCountryAr = (value) => {
    setItem({ ...item, countryAr: value });
  };
  const handleChangeCityEn = (value) => {
    setItem({ ...item, cityEn: value });
  };
  const handleChangeCityAr = (value) => {
    setItem({ ...item, cityAr: value });
  };
  const handleChangeTypeEn = (value) => {
    setItem({ ...item, typeEn: value });
  };
  const handleChangeTypeAr = (value) => {
    setItem({ ...item, typeAr: value });
  };
  const handleChangeModalsNumber = (value) => {
    setItem({ ...item, modalsNumber: value });
  };
  const handleChangeTotalunits = (value) => {
    setItem({ ...item, totalUnits: value });
  };
  const handleChangeStartDateEn = (value) => {
    setItem({ ...item, startDateEn: value });
  };
  const handleChangeStartDateAr = (value) => {
    setItem({ ...item, startDateAr: value });
  };
  const handleChangeEndDateEn = (value) => {
    setItem({ ...item, endDateEn: value });
  };
  const handleChangeEndDateAr = (value) => {
    setItem({ ...item, endDateAr: value });
  };
  const handleChangeMetaTitleEn = (value) => {
    setItem({ ...item, seoTitleEn: value });
  };
  const handleChangeMetaDescriptionEn = (value) => {
    setItem({ ...item, seoDescriptionEn: value });
  };
  const handleChangeChecked = (value) => {
    setItem({ ...item, active: value });
  };
  const handleChangeAvailable = (value) => {
    setItem({ ...item, available: value });
  };
  const handleChangeFeatured = (value) => {
    setItem({ ...item, featured: value });
  };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
    "image/webp",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs,webp and jsons"}
    />
  );
  const uploadedFile = file && (
    <Stack>
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "project");
    form_data.append("image", file[file.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeySeo.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          seoImage:
            validImageTypes.indexOf(file[file.length - 1].type) > 0
              ? window.URL.createObjectURL(file[file.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [filesMain, setFilesMain] = useState();
  const handleDropZoneMain = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesMain((filesMain) => acceptedFiles[0]),
    []
  );
  const fileUploadMain = !filesMain && <DropZone.FileUpload />;
  const uploadedFilesMain = filesMain && (
    <Stack>
      <div className="maxtextwidth">
        {filesMain.name}{" "}
        <Text variant="bodySm" as="p">
          {filesMain.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const [imageError, setImageError] = useState("");

  const imageKey = useRef("");
  const imageKeyThumbnail = useRef("");
  const imageKeySeo = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImageMain = (filesMain) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "project");
    form_data.append("image", filesMain[filesMain.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(filesMain[filesMain.length - 1].type) > 0
              ? window.URL.createObjectURL(filesMain[filesMain.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesThumbnail, setFilesThumbnail] = useState();
  const handleDropZoneThumbnail = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesThumbnail((filesThumbnail) => acceptedFiles[0]),
    []
  );
  const fileUploadThumbnail = !filesThumbnail && <DropZone.FileUpload />;
  const uploadedFilesThumbnail = filesThumbnail && (
    <Stack>
      <div className="maxtextwidth">
        {filesThumbnail.name}{" "}
        <Text variant="bodySm" as="p">
          {filesThumbnail.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageThumbnail = (filesThumbnail) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "project");
    form_data.append("image", filesThumbnail[filesThumbnail.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeyThumbnail.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          logo:
            validImageTypes.indexOf(
              filesThumbnail[filesThumbnail.length - 1].type
            ) > 0
              ? window.URL.createObjectURL(
                  filesThumbnail[filesThumbnail.length - 1]
                )
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [activeToast, setActiveToast] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const [item, setItem] = useState({
    titleEn: "",
    titleAr: "",
    countryEn: "",
    countryAr: "",
    cityEn: "",
    cityAr: "",
    startDateEn: "",
    startDateAr: "",
    descriptionEn: "",
    descriptionAr: "",
    text: "",
    image: "",
    logo: "",
    seoImage: "",
    seoTitleEn: "",
    seoDescriptionEn: "",
    seoImage: "",
    active: true,
    endDateEn: "",
    endDateAr: "",
    available: true,
    typeEn: "",
    typeAr: "",
    modalsNumber: "",
    totalUnits: "",
    featured: true,
    ctaLink: "",
  });
  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/projects/${id}`)
        .then((result) => {
          console.log(result?.data?.data);
          setIsSaving(false);
          setItem({
            titleEn:
              result?.data?.data?.name && result?.data?.data?.name?.en
                ? result.data.data.name?.en
                : "",
            titleAr:
              result?.data?.data?.name && result?.data?.data?.name?.ar
                ? result.data.data.name?.ar
                : "",
            countryEn:
              result?.data?.data?.country && result?.data?.data?.country?.en
                ? result.data.data.country?.en
                : "",
            countryAr:
              result?.data?.data?.country && result?.data?.data?.country?.ar
                ? result.data.data.country?.ar
                : "",
            cityEn:
              result?.data?.data?.city && result?.data?.data?.city?.en
                ? result.data.data.city?.en
                : "",
            cityAr:
              result?.data?.data?.city && result?.data?.data?.city?.ar
                ? result.data.data.city?.ar
                : "",
            typeEn:
              result?.data?.data?.type && result?.data?.data?.type?.en
                ? result.data.data.type?.en
                : "",
            typeAr:
              result?.data?.data?.type && result?.data?.data?.type?.ar
                ? result.data.data.type?.ar
                : "",
            descriptionEn:
              result?.data?.data?.description &&
              result?.data?.data?.description?.en
                ? result.data.data.description?.en
                : "",
            descriptionAr:
              result?.data?.data?.description &&
              result?.data?.data?.description?.ar
                ? result.data.data.description?.ar
                : "",
            image: result?.data?.data?.image ? result.data.data.image : "",
            startDateEn: result?.data?.data?.start_date
              ? result.data.data.start_date
              : "",
            endDateEn: result?.data?.data?.end_date
              ? result.data.data.end_date
              : "",

            logo: result?.data?.data?.logo ? result.data.data.logo : "",
            modalsNumber:
              result?.data?.data?.total_models !== null
                ? String(result?.data?.data?.total_models)
                : "",
            totalUnits:
              result?.data?.data?.total_units !== null
                ? String(result?.data?.data?.total_units)
                : "",
            active: result?.data?.data?.is_active ? true : false,
            available: result?.data?.data?.is_available ? true : false,
            featured: result?.data?.data?.is_featured ? true : false,
            ctaLink: result?.data?.data?.cta_link
              ? result.data.data.cta_link
              : "",
          });
        })
        .catch((err) => console.log(err));
  }, []);
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Project`}
      breadcrumbs={[
        {
          onAction: () => navigate(`/admin/projects-innovest`),
        },
      ]}
    >
      <FormLayout>
        <Card sectioned>
          <FormLayout>
            <FormLayout.Group>
              <TextField
                label="Name En"
                value={item.titleEn}
                onChange={handleChangeTitleEn}
              />

              <TextField
                label="Name Ar"
                value={item.titleAr}
                onChange={handleChangeTitleAr}
                align="right"
              />
            </FormLayout.Group>
            <InlineError message={titleError} />

            <FormLayout.Group>
              <TextField
                label="Country En"
                value={item.countryEn}
                onChange={handleChangeCountryEn}
              />

              <TextField
                label="Country Ar"
                value={item.countryAr}
                onChange={handleChangeCountryAr}
                align="right"
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="City En"
                value={item.cityEn}
                onChange={handleChangeCityEn}
              />

              <TextField
                label="City Ar"
                value={item.cityAr}
                onChange={handleChangeCityAr}
                align="right"
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="Type En"
                value={item.typeEn}
                onChange={handleChangeTypeEn}
              />

              <TextField
                label="Type Ar"
                value={item.typeAr}
                onChange={handleChangeTypeAr}
                align="right"
              />
            </FormLayout.Group>

            <FormLayout.Group>
              <TextField
                label="Models Number"
                value={item.modalsNumber}
                onChange={handleChangeModalsNumber}
                type="number"
              />

              <TextField
                label="Total Units"
                value={item.totalUnits}
                onChange={handleChangeTotalunits}
                type="number"
              />
            </FormLayout.Group>

            <FormLayout.Group>
              <TextField
                label="Start Date"
                value={item.startDateEn}
                onChange={handleChangeStartDateEn}
                type="date"
              />
              <TextField
                label="End Date"
                value={item.endDateEn}
                onChange={handleChangeEndDateEn}
                type="date"
              />
              {/* <TextField
                label="Start Date Ar"
                value={item.startDateAr}
                onChange={handleChangeStartDateAr}
              /> */}
            </FormLayout.Group>
            {/* <FormLayout.Group>
              <TextField
                label="End Date En"
                value={item.endDateEn}
                onChange={handleChangeEndDateEn}
              />
              <TextField
                label="End Date Ar"
                value={item.endDateAr}
                onChange={handleChangeEndDateAr}
              />
            </FormLayout.Group> */}

            <FormLayout.Group>
              <TextField
                label="Description En"
                value={item.descriptionEn}
                onChange={handleChangeDescriptionEn}
                multiline={4}
              />

              <TextField
                label="Description Ar"
                value={item.descriptionAr}
                onChange={handleChangeDescriptionAr}
                align="right"
                multiline={4}
              />
            </FormLayout.Group>
            <TextField
              label="CTA Link"
              value={item.ctaLink}
              onChange={handleChangeCtaLink}
            />
            <FormLayout.Group>
              <FormLayout>
                <Text as="p" fontWeight="regular">
                  Image
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.image ? item.image : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      onDrop={handleDropZoneMain}
                      onDropAccepted={sendImageMain}
                      allowMultiple={false}

                      // variableHeight
                    >
                      {uploadedFilesMain}
                      {fileUploadMain}
                    </DropZone>
                  </div>
                </div>
                <InlineError message={imageError} />
              </FormLayout>
              <FormLayout>
                <Text as="p" fontWeight="regular">
                  Logo
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.logo ? item.logo : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      onDrop={handleDropZoneThumbnail}
                      onDropAccepted={sendImageThumbnail}
                      allowMultiple={false}
                      // variableHeight
                    >
                      {uploadedFilesThumbnail}
                      {fileUploadThumbnail}
                    </DropZone>
                  </div>
                </div>
              </FormLayout>
            </FormLayout.Group>
            <Checkbox
              label="Is Available"
              checked={item.available}
              onChange={handleChangeAvailable}
            />
            <Checkbox
              label="Is Featured"
              checked={item.featured}
              onChange={handleChangeFeatured}
            />
            <Checkbox
              label="Is Active"
              checked={item.active}
              onChange={handleChangeChecked}
            />
          </FormLayout>
        </Card>
        {/* <Card sectioned titleEn="Search engine listing preview">
          <FormLayout>
            <Text variant="bodyMd" as="p" fontWeight="regular">
              SEO Image
            </Text>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div style={{ float: "left" }}>
                <Thumbnail
                  size="large"
                  source={item.seoImage ? item.seoImage : ""}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  marginLeft: "10px",
                }}
              >
                <DropZone
                  accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                  //   type="file"
                  allowMultiple={false}
                  onDrop={handleDropZoneDrop}
                  onDropAccepted={sendImage}
                >
                  {uploadedFile}
                  {fileUpload}
                </DropZone>
              </div>
            </div>
            <TextField
              label="Page TitleEn"
              value={item.seoTitleEn}
              onChange={handleChangeMetaTitleEn}
            />
            <TextField
              label="DescriptionEn"
              value={item.seoDescriptionEn}
              onChange={handleChangeMetaDescriptionEn}
              multiline={4}
            />
          </FormLayout>
        </Card> */}
      </FormLayout>

      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && [
            {
              content: "Delete",
              destructive: true,
              loading: isSaving && true,
              onClick: () => {
                setIsSaving(true);
                axios
                  .delete(`/projects/${id}`)
                  .then((result) => {
                    navigate(`/admin/projects-innovest`);
                  })
                  .catch((err) => console.log(err));
              },
            },
          ]
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.titleEn && !item.titleAr) {
      !item.titleEn && !item.titleAr && setTitleError("Please enter a name");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("name[en]", item.titleEn);
      form_data.append("name[ar]", item.titleAr);
      form_data.append("country[en]", item.countryEn);
      form_data.append("country[ar]", item.countryAr);
      form_data.append("city[en]", item.cityEn);
      form_data.append("city[ar]", item.cityAr);
      item.startDateEn && form_data.append("start_date", item.startDateEn);
      // form_data.append("start_date[ar]", item.startDateAr);
      item.endDateEn && form_data.append("end_date", item.endDateEn);
      // form_data.append("send_date[ar]", item.endDateAr);
      form_data.append("description[en]", item.descriptionEn);
      form_data.append("description[ar]", item.descriptionAr);
      form_data.append("type[en]", item.typeEn);
      form_data.append("type[ar]", item.typeAr);
      form_data.append("total_models", item.modalsNumber);
      form_data.append("total_units", item.totalUnits);
      filesMain && form_data.append("image", imageKey.current);
      filesThumbnail && form_data.append("logo", imageKeyThumbnail.current);
      form_data.append("cta_link", item.ctaLink);
      // form_data.append("seo_titleEn", item.seoTitleEn);
      // form_data.append("seo_descriptionEn", item.seoDescriptionEn);
      // form_data.append("vimeo_id", item.endDateEn);
      // file && form_data.append("seo_image", imageKeySeo.current);
      form_data.append("is_active", item.active ? 1 : 0);
      form_data.append("is_available", item.available ? 1 : 0);
      form_data.append("is_featured", item.featured ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");

      axios
        .post(`/projects${props.type === "edit" ? `/${id}` : ""}`, form_data)
        .then((res) => {
          if (props.type === "add") {
            navigate(`/admin/projects-innovest`);
          } else {
            setIsSaving(false);
            setToastContent("Changes have been saved succesffully");
            toggleActiveToast();
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            setIsSaving(false);
          } else if (error.request) {
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};

export default AddEditProjectInnovest;
